/* Kerzen Pfeilstetter — Cart Drawer
   Schlanker Slide-in-Warenkorb über die Shopify Cart AJAX API.
   Die gerenderte Drawer-Section wird direkt aus den add.js/change.js-Antworten
   geholt (sections-Parameter) — atomar, ohne zweiten (ggf. veralteten) Request.
   Event-Delegation, damit nach jedem Re-Render nichts neu gebunden werden muss. */
(function () {
  'use strict';

  var SECTION_ID = 'cart-drawer';
  var isOpen = false;
  var bound = false;

  function drawer() { return document.getElementById('CartDrawer'); }

  function open() {
    var d = drawer();
    if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    isOpen = true;
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = d.querySelector('[data-cart-close]');
    if (closeBtn && closeBtn.focus) closeBtn.focus();
  }

  function close() {
    var d = drawer();
    if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    isOpen = false;
    document.documentElement.style.overflow = '';
  }

  function autoOpenEnabled() {
    var d = drawer();
    return d && d.getAttribute('data-auto-open') === 'true';
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Kurzes „Andocken" am Warenkorb-Icon, wenn das Thumbnail ankommt.
  function bumpCart(target) {
    if (!target) return;
    target.classList.remove('cart-bump');
    void target.offsetWidth;
    target.classList.add('cart-bump');
  }

  // Produkt-Thumbnail im Bogen zum Warenkorb-Icon fliegen lassen.
  // Startet sofort beim Klick (parallel zum Request). Liefert ein Promise,
  // das auflöst, wenn das Thumbnail angekommen ist.
  // Größtes sichtbar gerendertes Bild im Produktbereich finden (= Hauptbild).
  // Robust gegen wechselndes Markup: nicht an eine bestimmte Klasse gebunden.
  function findProductImage(form) {
    var scope = form.closest('.product') || form.closest('[id^="shopify-section"]') || document;
    var best = null, bestArea = 0;
    scope.querySelectorAll('img').forEach(function (im) {
      var r = im.getBoundingClientRect();
      var area = r.width * r.height;
      // Mini-Bilder/Icons ignorieren
      if (area > bestArea && r.width >= 60 && r.height >= 60) { bestArea = area; best = im; }
    });
    return best;
  }

  function flyToCart(form, startEl) {
    return new Promise(function (resolve) {
      if (!('animate' in Element.prototype)) { resolve(); return; }
      var img = findProductImage(form);                 // Quelle: das Produktbild (was wird hinzugefügt)
      var anchor = startEl || form;                     // Startposition: der geklickte Button
      var target = document.querySelector('[data-cart-drawer-open]');
      if (!img || !target) { resolve(); return; }

      var ar = anchor.getBoundingClientRect();
      var tr = target.getBoundingClientRect();
      if (!ar.width || !tr.width) { resolve(); return; }

      // Thumbnail zentriert auf dem Button starten
      var size = 72;
      var ir = { left: ar.left + ar.width / 2 - size / 2, top: ar.top + ar.height / 2 - size / 2, width: size, height: size };

      var clone = document.createElement('img');
      clone.src = img.currentSrc || img.src;
      clone.setAttribute('aria-hidden', 'true');
      clone.style.cssText =
        'position:fixed;z-index:200;pointer-events:none;border-radius:0;object-fit:cover;' +
        'box-shadow:0 8px 24px rgba(20,30,25,.25);margin:0;' +
        'left:' + ir.left + 'px;top:' + ir.top + 'px;width:' + ir.width + 'px;height:' + ir.height + 'px;';
      document.body.appendChild(clone);

      var sx = ir.left + ir.width / 2, sy = ir.top + ir.height / 2;
      var ex = tr.left + tr.width / 2, ey = tr.top + tr.height / 2;
      // Kontrollpunkt über der Verbindungslinie → Bogen nach oben
      var cx = (sx + ex) / 2;
      var cy = Math.min(sy, ey) - Math.max(120, Math.abs(ex - sx) * 0.28);

      var N = 18, frames = [];
      for (var i = 0; i <= N; i++) {
        var t = i / N, mt = 1 - t;
        var bx = mt * mt * sx + 2 * mt * t * cx + t * t * ex;
        var by = mt * mt * sy + 2 * mt * t * cy + t * t * ey;
        frames.push({
          transform: 'translate(' + (bx - sx) + 'px,' + (by - sy) + 'px) scale(' + (1 - 0.82 * t) + ') rotate(' + (t * 35) + 'deg)',
          opacity: t > 0.82 ? (1 - (t - 0.82) / 0.18) : 1,
          offset: t
        });
      }

      var anim = clone.animate(frames, { duration: 680, easing: 'cubic-bezier(.5,.05,.7,.2)', fill: 'forwards' });
      var done = false;
      function finish() { if (done) return; done = true; if (clone.parentNode) clone.remove(); bumpCart(target); resolve(); }
      anim.onfinish = finish;
      setTimeout(finish, 1100);
    });
  }

  // Nur den INHALT des Panels aus einer add.js/change.js-Antwort ersetzen.
  // Das Panel-Element und der äußere Drawer bleiben bestehen → der Slide-Zustand
  // (transform) geht nicht verloren und Mengenänderungen lösen kein Reinsliden aus.
  function renderFromResponse(data) {
    // Aktuellen Balkenstand merken, damit die neue Bar von dort animieren kann
    var oldBar = document.querySelector('#CartDrawer .cart-drawer__fsb-bar');
    var oldWidth = oldBar ? oldBar.style.width : null;

    var html = data && data.sections && data.sections[SECTION_ID];
    if (html != null) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var freshPanel = tmp.querySelector('.cart-drawer__panel');
      var curPanel = document.querySelector('#CartDrawer .cart-drawer__panel');
      if (freshPanel && curPanel) curPanel.innerHTML = freshPanel.innerHTML;
    }
    syncCount();

    // Neue Progressbar auf den ALTEN Wert setzen, Zielwert merken → später animieren
    var bar = document.querySelector('#CartDrawer .cart-drawer__fsb-bar');
    if (bar) {
      bar.dataset.target = bar.style.width || '0%';
      bar.style.transition = 'none';
      bar.style.width = (oldWidth != null ? oldWidth : '0%');
      void bar.offsetWidth;        // Reflow, damit der Startwert „sitzt"
      bar.style.transition = '';   // zurück zur CSS-Transition
    }
    return bar;
  }

  // Progressbar auf den Zielwert wachsen lassen (+ kurzer Puls). Erst aufrufen,
  // wenn der Drawer offen ist, damit der Nutzer die Bewegung sieht.
  function animateFsb(bar, delay) {
    if (!bar) return;
    window.setTimeout(function () {
      var target = bar.dataset ? bar.dataset.target : null;
      if (target == null) return;
      bar.style.width = target;
      var fsb = bar.closest && bar.closest('.cart-drawer__fsb');
      if (fsb) { fsb.classList.remove('fsb-pulse'); void fsb.offsetWidth; fsb.classList.add('fsb-pulse'); }
    }, delay || 0);
  }

  // Header-Counter aus dem frisch gerenderten Drawer übernehmen (kein extra Fetch).
  function syncCount() {
    var src = document.querySelector('#shopify-section-' + SECTION_ID + ' [data-cart-count]');
    if (!src) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = src.textContent;
    });
  }

  function sectionsPayload() {
    return { id: SECTION_ID, url: window.location.pathname };
  }

  function findItem(key) {
    var items = document.querySelectorAll('#CartDrawer .cart-item');
    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute('data-cart-key') === key) return items[i];
    }
    return null;
  }

  function changeItem(key, quantity) {
    // Nur das betroffene Line Item dimmen, nicht den ganzen Drawer
    var item = findItem(key);
    if (item) item.classList.add('is-loading');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: SECTION_ID,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { animateFsb(renderFromResponse(data), 30); })  // Drawer offen → direkt animieren
      .catch(function () { if (item) item.classList.remove('is-loading'); });
  }

  function bind() {
    if (bound) return;
    bound = true;

    // „In den Warenkorb" abfangen → AJAX (inkl. Section) → Drawer öffnen
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[name="add"]');
      if (btn) btn.setAttribute('disabled', '');

      // Thumbnail SOFORT losfliegen lassen (parallel zum Request)
      var fly = prefersReducedMotion() ? Promise.resolve() : flyToCart(form, btn);

      // Leere optionale Line Item Properties nicht mitsenden
      form.querySelectorAll('[data-optional-property]').forEach(function (input) {
        input.disabled = !input.value || !input.value.trim();
      });
      var body = new FormData(form);
      form.querySelectorAll('[data-optional-property]').forEach(function (input) { input.disabled = false; });

      // Aktualisierte Drawer-Section direkt mit der add.js-Antwort anfordern
      body.append('sections', SECTION_ID);
      body.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', { method: 'POST', body: body, headers: { 'Accept': 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function (data) {
          var bar = renderFromResponse(data);
          if (autoOpenEnabled()) {
            // Drawer erst öffnen, wenn das Thumbnail angekommen ist,
            // dann die Progressbar wachsen lassen (sichtbar im offenen Drawer)
            fly.then(function () { open(); animateFsb(bar, 350); });
          } else {
            animateFsb(bar, 30);
          }
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) btn.removeAttribute('disabled'); });
    });

    // Klicks: öffnen / schließen / Menge / entfernen
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-cart-close]')) { close(); return; }

      var item = e.target.closest('.cart-item');
      if (!item) return;
      var minus = e.target.closest('[data-cart-minus]');
      var plus = e.target.closest('[data-cart-plus]');
      var remove = e.target.closest('[data-cart-remove]');
      if (!minus && !plus && !remove) return;

      var input = item.querySelector('[data-cart-qty]');
      var qty = parseInt(input && input.value, 10) || 0;
      if (remove) qty = 0;
      else if (plus) qty += 1;
      else if (minus) qty = Math.max(0, qty - 1);
      changeItem(item.getAttribute('data-cart-key'), qty);
    });

    // Mengenfeld direkt editiert
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      var item = input.closest('.cart-item');
      if (!item) return;
      changeItem(item.getAttribute('data-cart-key'), Math.max(0, parseInt(input.value, 10) || 0));
    });

    // ESC schließt
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close();
    });
  }

  bind();
})();
